import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";

export class TransactionService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTransactionListData(
        fundID,
        fullName,
        groupName,
        groupCode,
        startDate,
        endDate,
        status,
        page,
        size,
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/payment-transactions`,
                {
                    page,
                    size,
                    "full-name": fullName,
                    "group-code": groupCode,
                    "group-name": groupName,
                    "start-pay-at": startDate && startDate.length === 10 ? convertPersianDateToUniversalDate(startDate) : "",
                    "end-pay-at": endDate && endDate.length === 10 ? convertPersianDateToUniversalDate(endDate) : "",
                    status: status === "ALL" ? "" : status,
                }
            ).then(resolve).catch(reject)
        })
    }

    getTransactionInformation(fundID,transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/payment-transactions/${transactionId}`
            ).then(resolve).catch(reject)
        })
    }
}